import request from '@/utils/request'

// 查询列表
export function apiInvWipAllocationPlanCompartmentList (query) {
  return request({
    url: '/inv/invWipAllocationPlan/compartmentList',
    method: 'get',
    params: query
  })
}

// 明细
export function apiInvWipAllocationPlanDetailList (query) {
  return request({
    url: '/inv/invWipAllocationPlanDetail/list',
    method: 'get',
    params: query
  })
}

// 修改
export function apiInvWipAllocationPlanCompartmentUpdate (data) {
  return request({
    url: '/inv/invWipAllocationPlan/compartmentUpdate',
    method: 'post',
    data: data
  })
}

// 批量修改目的仓库
export function apiInvWipAllocationPlanCompartmentBatchUpdateWarehouse (data) {
  return request({
    url: '/inv/invWipAllocationPlan/compartmentBatchUpdateWarehouse',
    method: 'post',
    data: data
  })
}

// 发布
export function apiInvWipAllocationPlanCompartmentRelease (data) {
  return request({
    url: '/inv/invWipAllocationPlan/compartmentRelease',
    method: 'post',
    data: data
  })
}

// 执行运算
export function apiInvWipAllocationPlanCompartmentOperations (data) {
  return request({
    url: '/inv/invWipAllocationPlan/compartmentOperations',
    method: 'post',
    data: data
  })
}

// 导出汇总列表
export function apiInvWipAllocationPlanNewExport (data) {
  return request({
    url: '/inv/invWipAllocationPlan/v2/compartmentExport',
    method: 'post',
    data: data
  })
}

// 导出明细列表
export function apiInvWipAllocationPlanNewDetailExport (data) {
  return request({
    url: '/inv/invWipAllocationPlanDetail/v2/compartmentDetailExport',
    method: 'post',
    data: data
  })
}

// 作废
export function apiInvWipAllocationPlanCompartmentCancel (data) {
  return request({
    url: '/inv/invWipAllocationPlan/compartmentCancel',
    method: 'post',
    data: data
  })
}

// 批量修改调拨到仓日期
export function apiInvWipAllocationPlanDispatchBatchUpdate (data) {
  return request({
    url: '/inv/invWipAllocationPlan/dispatchBatchUpdate',
    method: 'post',
    data: data
  })
}
